/* esm.sh - date-fns@4.1.0/locale/_lib/buildFormatLongFn */
function r(t){return(d={})=>{let n=d.width?String(d.width):t.defaultWidth;return t.formats[n]||t.formats[t.defaultWidth]}}export{r as buildFormatLongFn};
//# sourceMappingURL=buildFormatLongFn.mjs.map